module.exports = __webpack_public_path__ + "img/html.21648119.png";